// extracted by mini-css-extract-plugin
export default {"container":"orders_container__8vng4","additionalInfoHeading":"orders_additionalInfoHeading__xa0+j","additionalInfo":"orders_additionalInfo__579He"};